import { gql } from '@apollo/client';

import { FileInfoFragment } from '@modules/shared/graphql';

export const GetTestingQuestionQuery = gql`
    query GetTestingQuestion($id: ID!) {
        getOLTestQuestion(id: $id) {
            id
            subjectId
            text
            photoIds
            correctAnswersCount
            answers {
                id
                text
                photo {
                    ...FileInfo
                }
            }
            photos {
                ...FileInfo
            }
        }
    }
    ${FileInfoFragment}
`;
